import React, { useState } from "react";
import { Modal, Button, Form, Alert, Spinner } from "react-bootstrap";
import axiosClient from "../../api/axiosClient";

const CreateUserModal = ({ show, onHide }) => {
  const [form, setForm] = useState({
    username: "",
    password: "",
    email: "",
    status: true
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === "checkbox" ? checked : value });
  };

  const handleSubmit = async () => {
    setLoading(true);
    setMessage("");

    try {
      const res = await axiosClient.post("/users", form);
      setMessage("User created successfully!");
      setLoading(false);

      setTimeout(() => {
        onHide();
        window.location.reload(); // refresh list
      }, 1000);

    } catch (err) {
      setMessage(err.response?.data?.message || "Failed to create user");
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Create VIP User</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {message && <Alert variant="info">{message}</Alert>}

        <Form.Group className="mb-3">
          <Form.Label>Username</Form.Label>
          <Form.Control 
            name="username"
            value={form.username}
            onChange={handleChange}
            placeholder="Enter username"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Password</Form.Label>
          <Form.Control 
            type="password"
            name="password"
            value={form.password}
            onChange={handleChange}
            placeholder="Enter password"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Email</Form.Label>
          <Form.Control 
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder="Enter email"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Check 
            type="checkbox"
            name="status"
            label="Active"
            checked={form.status}
            onChange={handleChange}
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? <Spinner size="sm" /> : "Create User"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateUserModal;
